import React from "react";
import Select from "react-select";
import { Field } from "formik";

import Error from "./error";

function Dropdown({ placeholder, options, ...props }) {
	const SelectStyles = {
		control: (baseStyles, state) => ({
			...baseStyles,
			height: "50px",
			fontFamily: "Roboto",
			textTransform: "capitalize",
			backgroundColor: state.hasValue ? "white" : "#E4E5E7",
			color: "#18191B",
			borderColor: state.hasValue ? "grey" : state.isFocused ? "grey" : "#E4E5E7",
			boxShadow: "none",
			borderRadius: "10px",
			paddingLeft: "0.75rem",
			marginBottom: props.marginBottom ? props.marginBottom : "0",
			marginRight: props.marginRight ? props.marginRight : "0",
			"&:hover": {
				borderColor: state.hasValue ? "grey" : state.isFocused ? "grey" : "#E4E5E7",
			},
			// "&:focus": {
			// 	borderColor: baseStyles.borderColor,
			// },
		}),
		option: (baseStyles, state) => ({
			...baseStyles,
			color: "#18191B",
			paddingLeft: "0.75rem",
			fontFamily: "Roboto",
			backgroundColor: state.isSelected ? "transparent" : baseStyles.backgroundColor,
			fontWeight: state.isSelected ? "700" : baseStyles.fontWeight,
			textTransform: "capitalize",
		}),
		placeholder: (baseStyles) => ({
			...baseStyles,
			color: "#18191B",
			fontFamily: "Roboto",
		}),
		singleValue: (baseStyles) => ({
			...baseStyles,
			color: "#18191B",
			fontFamily: "Roboto",
			textTransform: "capitalize",
		}),
		indicatorSeparator: () => ({
			display: "none",
		}),
		dropdownIndicator: (baseStyles) => ({
			...baseStyles,
			color: "#18191B",
		}),
		menu: (baseStyles) => ({
			...baseStyles,
			zIndex: 99999,
		}),
	};

	return (
		<React.Fragment>
			<Field name={props.name}>
				{({ field, form }) => {
					const selectedOption = options.find((option) => option.value === field.value) || (field.value == "" ? null : { value: field.value, label: field.value });
					return (
						<Select
							{...field}
							styles={SelectStyles}
							placeholder={placeholder}
							// value={options.length > 0 ? options.find(option => option.value === field.value) : field.value ? { value: field.value, label: field.value } : null}
							value={selectedOption}
							onChange={(option) => {
								// form.setFieldValue(field.name, option.value);
								props.onChange(option.value);
							}}
							onBlur={() => form.setFieldTouched(field.name, true)}
							options={options}
							isSearchable={false}
							noOptionsMessage={() => (props.noOptionsMessage ? props.noOptionsMessage : null)}
							menuPortalTarget={document.body}
							menuPosition="fixed"
							// autoFocus={true}
							// openMenuOnFocus={true}
							// required
						/>
					);
				}}
			</Field>
			{props.error && <Error text={props.error} />}
		</React.Fragment>
	);
}

export default Dropdown;
